import React, { useContext } from 'react';
import { connect } from 'react-redux';
import { createStructuredSelector } from 'reselect';
import { Modal } from 'semantic-ui-react';

import { AppState } from 'services/types';
import { updateQueryString as updateQueryStringAction } from 'services/router/actions';
import {
    makeSelectQueryStringValue
    // @ts-ignore
} from 'workspaces/react-router-selectors';

import { VirtualizedTableContextProviderValue } from '../../types';
import VirtualizedTableEditFormWrapper from '../VirtualizedTableEditFormWrapper';
import VirtualizedTableContext from '../VirtualizedTableContext';
import { EDIT_MODAL_QUERY_STRING_PARAM } from '../../constants';

interface ConnectedProps {
    queryStringValue: ReturnType<ReturnType<typeof makeSelectQueryStringValue>>;
}

interface DispatchProps {
    updateQueryString: typeof updateQueryStringAction;
}

type Props = ConnectedProps & DispatchProps;

export const VirtualizedTableEditModalComponent = (
    props: Props
): React.ReactElement => {
    const {
        label,
        modalSize = 'fullscreen'
    }: VirtualizedTableContextProviderValue = useContext(
        VirtualizedTableContext
    );
    const { queryStringValue } = props;

    const handleClose = (): void => {
        props.updateQueryString({
            [EDIT_MODAL_QUERY_STRING_PARAM]: undefined
        });
    };
    const className =
        modalSize === 'fullscreen' ? 'constrain-width' : undefined;

    return (
        <Modal
            size={modalSize}
            open={!!queryStringValue}
            centered={false}
            onClose={handleClose}
            closeIcon
        >
            <Modal.Header>Edit{label ? ` ${label}` : ''}</Modal.Header>
            <Modal.Content className={className}>
                <VirtualizedTableEditFormWrapper itemKey={queryStringValue} />
            </Modal.Content>
        </Modal>
    );
};

const mapStateToProps = createStructuredSelector<AppState, {}, ConnectedProps>({
    queryStringValue: makeSelectQueryStringValue(EDIT_MODAL_QUERY_STRING_PARAM)
});

export default connect(mapStateToProps, {
    updateQueryString: updateQueryStringAction
})(VirtualizedTableEditModalComponent);
